const Poultry = process.env.PUBLIC_URL + '/assets/meat-types/chicken.png';
const Beef = process.env.PUBLIC_URL + '/assets/meat-types/beef.png';
const Fish = process.env.PUBLIC_URL + '/assets/meat-types/fish.png';
const Vegan = process.env.PUBLIC_URL + '/assets/meat-types/vegan.png';
const Pork = process.env.PUBLIC_URL + '/assets/meat-types/pork.png';
const Deer = process.env.PUBLIC_URL + '/assets/meat-types/deer.png';

export const splitMeatTypeValue = (meatType) => {
  if (Array.isArray(meatType)) {
    return meatType
      .map((value) => value?.trim())
      .filter(Boolean);
  }

  return `${meatType ?? ''}`
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);
};

export const getPrimaryMeatType = (meatType) => {
  const selectedMeatTypes = splitMeatTypeValue(meatType);

  if (selectedMeatTypes.length === 0) {
    return 'NotApplicable';
  }

  return (
    selectedMeatTypes.find((value) => value !== 'NotApplicable') ??
    'NotApplicable'
  );
};

export const formatMeatTypeLabel = (meatType) => {
  const selectedMeatTypes = splitMeatTypeValue(meatType);

  if (selectedMeatTypes.length === 0) {
    return 'Veg';
  }

  return selectedMeatTypes
    .map((value) => {
      if (value === 'NotApplicable') {
        return 'Veg';
      }

      if (value === 'Mutton') {
        return 'Lamb';
      }

      return value;
    })
    .join(', ');
};

export const getMeatTypeIconsUrl = (meatType) => {
  switch (getPrimaryMeatType(meatType)) {
    case 'Poultry':
      return Poultry;
    case 'Pork':
      return Pork;
    case 'Mutton':
    case 'Venison':
      return Deer;
    case 'Fish':
      return Fish;
    case 'NotApplicable':
      return Vegan;
    case 'Beef':
      return Beef;
    default:
      return Vegan;
  }
};
